import { Component, Input, OnInit, ElementRef } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  public TYPE_UPCOMING = 'upcoming';
  public TYPE_SCRIPTURES = 'scriptures';
  public TYPE_PRAYER_TOPICS = 'prayer-topics';
  public TYPE_HISTORY = 'history';

  public type: 'upcoming' | 'scriptures' | 'prayer-topics' | 'history';

  ngOnInit() {
    if ( this.elementRef ) {
      this.type = this.elementRef.nativeElement.getAttribute( 'type' );
    }
  }

  constructor( private elementRef: ElementRef ) {}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts